import { GrowthBookProvider as OriginalGrowthBookProvider } from '@growthbook/growthbook-react'
import { LazyMotion, domAnimation } from 'motion/react'

import growthbook from '../utils/growthbook'
import { OnboardingProvider } from '../features/onboarding/context'

import { ToastProvider } from './toast-context'
import { GrowthBookProvider } from './growthbook-context'
import { ThreeDSecureProvider } from './three-d-secure-context'
import { ReactQueryProvider } from './react-query-provider'

const CustomProviders = ({ children }) => (
  <LazyMotion features={domAnimation}>
    <OriginalGrowthBookProvider growthbook={growthbook}>
      <GrowthBookProvider>
        <OnboardingProvider>
          <ReactQueryProvider>
            <ToastProvider>
              <ThreeDSecureProvider>{children}</ThreeDSecureProvider>
            </ToastProvider>
          </ReactQueryProvider>
        </OnboardingProvider>
      </GrowthBookProvider>
    </OriginalGrowthBookProvider>
  </LazyMotion>
)

export default CustomProviders
